(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"), require("mggp-plugin-buffering"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player", "mggp-plugin-buffering"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-hls-fairplay"] = factory(require("mggp-player"), require("mggp-plugin-buffering"));
	else
		root["mggp-vendor-hls-fairplay"] = factory(root["mggp-player"], root["mggp-plugin-buffering"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_mggp_player__, __WEBPACK_EXTERNAL_MODULE_mggp_plugin_buffering__) => {
return 